export default "__VITE_ASSET__CNPRKtAB__"